import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from "@mui/material/styles";
import Logo from "src/components/logo";
import { useResponsive } from "src/hooks/use-responsive";
import AccountPopover from "./common/account-popover";
import { HEADER } from "./config-layout";
import navConfig from "./config-navigation";
import { usePathname } from "src/router/hooks";
import { ListItemButton } from "@mui/material";
import RouterLink from "src/router/router-link";
import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Header({ onOpenNav }: { onOpenNav: () => void }) {
  const theme = useTheme();
  const lgUp = useResponsive("up", "md");

  const renderMenu = (
    <Stack component="nav" direction="row" spacing={0.5} sx={{ px: 2 }}>
      {navConfig.map((item) => (
        <NavItem key={item.title} item={item} />
      ))}
    </Stack>
  );

  const renderContent = (
    <>
      <Logo
        sx={{
          height: 0.55,
          opacity: 1,
          mr: 3,
        }}
      />
      {lgUp && renderMenu}
      <Box sx={{ flexGrow: 1 }} />
      {!lgUp && (
        <IconButton id="nav-btn" onClick={onOpenNav} sx={{ mr: 1 }}>
          <MenuOutlinedIcon />
        </IconButton>
      )}
      {lgUp && (
        <Stack direction="row" alignItems="center" spacing={1}>
          <AccountPopover />
        </Stack>
      )}
    </>
  );

  return (
    <AppBar
      sx={{
        boxShadow: "none",
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        backgroundColor: lgUp ? "rgba(255, 255, 255, 0.6)" : "#ffffff",
        transition: theme.transitions.create(["height"], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp
          ? {
              width: 1,
              height: HEADER.H_DESKTOP,
            }
          : {}),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 2 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

function NavItem({ item }: any) {
  const pathname = usePathname();

  const active = item.path === pathname;

  return (
    <ListItemButton
      component={RouterLink}
      href={item.path}
      sx={{
        minHeight: 44,
        borderRadius: 0.75,
        typography: "body2",
        color: "primary.main",
        "&:hover": {
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
        },
        textTransform: "capitalize",
        fontFamily: '"Museo Sans", sans-serif',
        fontWeight: "fontWeightMedium",
        ...(active && {
          color: "primary.main",
          fontWeight: "fontWeightSemiBold",
          borderBottom: (theme) => `2px solid ${theme.palette.secondary.main}`,
        }),
      }}
    >
      <Box component="span">{item.title} </Box>
    </ListItemButton>
  );
}
